import { createContext, useContext, useState, useEffect } from 'react';
import { callApi } from './crud/utils';

const AppContext = createContext();

function AppContextProvider({ children }) {
  const [internalServerUrl, setInternalServerUrl] = useState(localStorage.getItem("serverUrl") ? localStorage.getItem("serverUrl") : '');
  const [internalGridTop, setInternalGridTop] = useState(localStorage.getItem("gridTop"));
  const [internalUser, setInternalUser] = useState(JSON.parse(sessionStorage.getItem("appUser")) ? JSON.parse(sessionStorage.getItem("appUser")) : null);
  const [internalSessionToken, setInternalSessionToken] = useState(JSON.parse(sessionStorage.getItem("sessionToken")) ? JSON.parse(sessionStorage.getItem("sessionToken")) : null);
  const [internalTheme, setInternalTheme] = useState('light');

  const [internalsideMenuOptions, setIinternalSideMenuOptions] = useState(JSON.parse(sessionStorage.getItem("sideMenuOptions")) ? JSON.parse(sessionStorage.getItem("sideMenuOptions")) : null)

  const setServerUrl = (serverUrl) => {
    localStorage.setItem("serverUrl", serverUrl);
    setInternalServerUrl(serverUrl);
  }
  const setGridTop = (gridTop) => {
    localStorage.setItem("gridTop", gridTop);
    setInternalGridTop(gridTop);
  }

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setInternalTheme(storedTheme);
    }
  }, []);

  const serverUrl = localStorage.getItem("serverUrl");
  const gridTop = localStorage.getItem("gridTop");


  useEffect(() => {
    setInternalServerUrl(serverUrl);
  }, [serverUrl]);

  useEffect(() => {
    setInternalGridTop(gridTop);
  }, [gridTop]);

  useEffect(() => {
    if (internalTheme === 'dark') {
      document.body.classList.add('dark-mode');
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.classList.remove('dark-mode');
      document.body.removeAttribute("data-bs-theme");
    }
  }, [internalTheme]);

  const setUser = (user) => {
    sessionStorage.setItem("appUser", JSON.stringify(user));
    if (JSON.parse(sessionStorage.getItem("appUser") || "null")) {
      setInternalUser(JSON.parse(sessionStorage.getItem("appUser") || "null"));
    } else {
      setInternalUser(user);
    }

  }

  const setTheme = (theme) => {
    localStorage.setItem("theme", theme);
    setInternalTheme(theme);
  }

  const setSessionToken = (sessionToken) => {
    let sessiontoken = sessionToken;
    if (sessiontoken) {
      let language = sessiontoken?.Language ? sessiontoken.Language : "el";
      sessiontoken["Language"] = language
    }
    sessionStorage.setItem("sessionToken", JSON.stringify(sessiontoken));
    setInternalSessionToken(sessiontoken);
  }

  const setSideMenuOptions = (sideMenuOptions) => {
    sessionStorage.setItem("sideMenuOptions", JSON.stringify(sideMenuOptions));
    setIinternalSideMenuOptions(sideMenuOptions);
  }
  const fetchAndSetCustomStyle = async () => {
    try {
      const apiUrl = internalServerUrl
        ? `${internalServerUrl}/api/GetCustomStyle`
        : '/api/GetCustomStyle';

      const response = await callApi('GET', apiUrl);

      // if (!response.ok) throw new Error('Failed to fetch custom style');

      if (response && response.CustomStyle) {
        const currentToken = JSON.parse(sessionStorage.getItem('sessionToken')) || {};

        const updatedToken = {
          ...currentToken,
          CustomStyle: JSON.stringify(response),
        };

        // console.log('Updated sessionToken with CustomStyle:', updatedToken);
        sessionStorage.setItem('sessionToken', JSON.stringify(updatedToken));
        setInternalSessionToken(updatedToken);
      }
    } catch (error) {
      console.error('Error fetching custom style:', error);
    }
  };


  let value = {
    serverUrl: internalServerUrl,
    gridTop: internalGridTop,
    user: internalUser,
    sessionToken: internalSessionToken,
    theme: internalTheme,
    sideMenuOptions: internalsideMenuOptions,
    setUser,
    setServerUrl,
    setGridTop,
    setSessionToken,
    setTheme,
    setSideMenuOptions,
    fetchAndSetCustomStyle
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}

function useApp() {
  return useContext(AppContext);
}

export default useApp;
export { AppContextProvider };
